'use client'

import { useQuery } from '@repo/tanstack/query'

import type { UserContactsData } from './types'

import { useAuth } from './context'

/**
 * Hook to fetch user contacts for the current user's company
 * Only fetches for transport/accounts company types
 */
export function useUserContacts() {
  const { apiUrl, source, token, user } = useAuth()
  const companyId = user?.company?.id
  const companyType = user?.company?.profile?.type

  const { data, isLoading, refetch } = useQuery({
    enabled: !!token && !!companyId && ['accounts', 'transport'].includes(companyType ?? ''),
    queryFn: async (): Promise<null | UserContactsData> => {
      if (!token || !companyId) return null

      const res = await fetch(
        `${apiUrl}/companies/${companyId}/contacts?filter[type]=transport,accounts`,
        {
          headers: {
            Accept: 'application/json',
            'App-Source': source,
            Authorization: `Bearer ${token}`,
          },
        },
      )
      if (!res.ok) return null
      return res.json()
    },
    queryKey: ['userContacts', companyId],
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  })

  return {
    contacts: data?.data ?? null,
    isLoading,
    refetch,
    userContacts: data,
  }
}
